"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTheme = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Elevation_1 = require("../../common/enums/Elevation");
var Button_1 = __importStar(require("../../components/button/Button"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var CardUtils_1 = require("./CardUtils");
var CardTheme;
(function (CardTheme) {
    CardTheme["DEFAULT"] = "default";
    CardTheme["FEATURED"] = "featured";
    CardTheme["SECONDARY"] = "secondary";
    CardTheme["VMC_PLAYBACK"] = "vmc-playback";
})(CardTheme = exports.CardTheme || (exports.CardTheme = {}));
var Card = function (props) {
    var children = props.children, classes = props.classes, dismissible = props.dismissible, dismissibleMedia = props.dismissibleMedia, elevation = props.elevation, onClick = props.onClick, onDismiss = props.onDismiss, style = props.style, theme = props.theme, staticPadding = props.staticPadding, whiteOnWhite = props.whiteOnWhite, otherProps = __rest(props, ["children", "classes", "dismissible", "dismissibleMedia", "elevation", "onClick", "onDismiss", "style", "theme", "staticPadding", "whiteOnWhite"]);
    return (react_1.default.createElement("div", __assign({ className: getClassNames(elevation, CardUtils_1.hasAction(children), theme, staticPadding, whiteOnWhite, classes), onClick: onClick, style: style }, otherProps),
        dismissible && (react_1.default.createElement("span", { className: "fds-card-dismiss" },
            react_1.default.createElement(Button_1.default, { type: Button_1.ButtonType.ROUND, onClick: onDismiss, variant: dismissibleMedia && Button_1.RoundButtonType.REVERSED || null },
                react_1.default.createElement(Icon_1.default, { name: "close" })))),
        children));
};
Card.defaultProps = {
    elevation: Elevation_1.DEFAULT_ELEVATION,
    theme: CardTheme.DEFAULT
};
var getClassNames = function (elevation, hasAction, theme, staticPadding, whiteOnWhite, classes) {
    var _a;
    return classnames_1.default('fds-card', 'fds-grid', (_a = {},
        _a["elevation-" + elevation] = (elevation && elevation !== Elevation_1.DEFAULT_ELEVATION),
        _a['has-action'] = hasAction,
        _a["fds-card-theme-" + theme.toLowerCase()] = (theme === CardTheme.FEATURED || theme === CardTheme.SECONDARY || theme === CardTheme.VMC_PLAYBACK),
        _a['fds-card-static-padding'] = staticPadding,
        _a['fds-white-on-white'] = whiteOnWhite,
        _a), classes);
};
exports.default = Card;
